(ns minorodata.components.forms.doc
  (:require ["lucide-react" :refer [MessageCircleQuestion]]
            [ui.utils :refer [clsx]]
            [ui.tooltip]))


(defn tooltip [{:keys [doc align-top class]}]
  [:div {:class (clsx "mr-1 mt-6 ml-2 cursor-help"
                      (if align-top
                        "self-start"
                        "self-bottom")
                      class)}
   [ui.tooltip/tooltip {:trigger-as-child true
                        :content [:div {:class "tooltip-container"}
                                  (if (string? doc)
                                    [:span doc]
                                    doc)]}
    [:> MessageCircleQuestion {}]]])
